module.exports = __webpack_public_path__ + "fonts/gothica1-extralight-webfont.3370ecd.woff";